import { INDUSTRY_PRESET_ORDER, type IndustryPresetKey } from "@/data/industryPresets";

export function isIndustryPresetKey(value: string | null | undefined): value is IndustryPresetKey {
    return Boolean(value && (INDUSTRY_PRESET_ORDER as string[]).includes(value));
}

type SearchParamsLike = { get(name: string): string | null } | null | undefined;

/** Matches IndustryPresetContext defaults: explicit ?preset=, beauty UTM, else horeca. */
export function resolveActivePresetKey(searchParams: SearchParamsLike): IndustryPresetKey {
    const preset = searchParams?.get("preset")?.toLowerCase();
    if (isIndustryPresetKey(preset)) return preset;
    const campaign = searchParams?.get("utm_campaign")?.toLowerCase() ?? "";
    if (campaign.includes("beauty_100") || campaign.includes("beauty100")) return "beauty";
    return "horeca";
}
